import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';

import { UserService } from '../services/user.service';
import { UrlService } from '../services/url.service';

@Injectable({
	providedIn: 'root',
})
export class AuthGuard implements CanActivate {

	constructor(
		private url: UrlService,
		private user: UserService
	) { }

	canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		if (state.url === '/logout') {
			console.log('logging out...');
			this.user.logout();
			this.url.get('login').navigate();
			return false;
		}

		const loggedIn = this.user.isLoggedIn$();

		if (!loggedIn) {
			const urlTree = this.url.parse(state.url);
			const urlWithoutParams = urlTree.root.children['primary']?.segments?.map(it => it.path)?.join('/') || 'trip';
			const tIdParam = urlTree.queryParams['tId'];
			this.user.tripIdParam = tIdParam;

			this.url.get('login').navigate({ returnUrl: urlWithoutParams });
		}

		return loggedIn;
	}
}
